"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotEmptyObject = exports.isEmptyObject = exports.objectEntries = void 0;
exports.objectKeys = objectKeys;
exports.deepMerge = deepMerge;
exports.deepEqual = deepEqual;
exports.parseEnumValue = parseEnumValue;
const typeChecker_1 = require("./typeChecker");
function objectKeys(obj) {
    return Object.keys(obj);
}
const objectEntries = (obj) => Object.entries(obj);
exports.objectEntries = objectEntries;
function deepMerge(prev, next) {
    function isObject(item) {
        return typeof item === 'object' && !Array.isArray(item) && item !== null;
    }
    function merge(target, source) {
        const result = { ...target };
        for (const key in source) {
            if (isObject(result[key]) && isObject(source[key])) {
                result[key] = merge(target[key], source[key]);
            }
            else {
                result[key] = source[key];
            }
        }
        return result;
    }
    if (!isObject(prev) || !isObject(next))
        throw Error('Only object can be merged');
    return merge({ ...prev }, next);
}
function deepEqual(obj1, obj2) {
    if (obj1 === obj2) {
        return true;
    }
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
        return false;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
        }
    }
    return true;
}
// 오직 비어있는 오브젝트인지 판단하기 위한 용도로 사용
const isEmptyObject = (obj) => {
    if (!obj || !(0, typeChecker_1.isObject)(obj)) {
        return false;
    }
    return !objectKeys(obj).length;
};
exports.isEmptyObject = isEmptyObject;
const isNotEmptyObject = (obj) => {
    if (!obj || !(0, typeChecker_1.isObject)(obj))
        return false;
    if (!objectKeys(obj).length) {
        return false;
    }
    return objectKeys(obj).length > 0;
};
exports.isNotEmptyObject = isNotEmptyObject;
function parseEnumValue(input) {
    var _a;
    const enumValues = Object.values(input.enum);
    for (const enumValue of enumValues) {
        if (enumValue.toString() === ((_a = input.value) === null || _a === void 0 ? void 0 : _a.toString())) {
            return enumValue;
        }
    }
    return input.default;
}
